import { ROUTE_PATH } from "@/common/constants/routing";
import { RepairSpecDtoAny } from "@/common/mapping/mappers/repairSpec";
import { AppPermission } from "@/core/api/generated/v1";

import {
  BaseEntityLink,
  BaseEntityLinkInheritableProps,
} from "../components/EntityLink/BaseEntityLink";
import RepairSpecInline, { RepairSpecInlineProps } from "./RepairSpecInline";

interface Props extends BaseEntityLinkInheritableProps {
  entity?: Nil<RepairSpecDtoAny>;
  entityId?: string | null;
  inlineProps?: Partial<RepairSpecInlineProps>;
}

export default function RepairSpecLink({ entity, entityId, inlineProps, ...otherProps }: Props) {
  return (
    <BaseEntityLink
      entity={entity}
      entityId={entityId}
      permissions={[AppPermission.FleetAppAccess, AppPermission.RepairCatalogRead]}
      to={ROUTE_PATH.REPAIR_SPEC_VIEW(entity?.id || entityId || "")}
      content={
        <RepairSpecInline
          entity={entity}
          entityId={entityId}
          {...inlineProps}
          withTooltip={false}
        />
      }
      {...otherProps}
    />
  );
}
